import * as React from 'react';
import {
    Button as ChakraButton,
    ButtonProps as ChakraButtonProps
} from '@chakra-ui/react';
import { RefObject } from 'react';

type ButtonProps = React.PropsWithChildren<ChakraButtonProps>;

export const Button = React.forwardRef(
    (
        props: React.PropsWithChildren<ButtonProps>,
        ref:
            | string
            | ((instance: HTMLButtonElement | null) => void)
            | RefObject<HTMLButtonElement>
            | null
            | undefined
    ) => {
        const { size = 'sm', colorScheme = 'ecp', ...rest } = props;

        return (
            <ChakraButton
                size={size}
                {...rest}
                colorScheme={colorScheme}
                ref={ref}>
                {props.children}
            </ChakraButton>
        );
    }
);

export const GhostButton = React.forwardRef(
    (
        props: React.PropsWithChildren<ButtonProps>,
        ref:
            | ((instance: HTMLButtonElement | null) => void)
            | RefObject<HTMLButtonElement>
            | null
            | undefined
    ) => {
        return (
            <Button {...props} variant="ghost" ref={ref}>
                {props.children}
            </Button>
        );
    }
);
